var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_3000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8C9.9 8 7.5 9 5.6 10.6L2 7V16H11L7.4 12.4C8.39865 11.5901 9.57778 11.0329 10.8375 10.7755C12.0972 10.5181 13.4005 10.5682 14.6367 10.9214C15.873 11.2746 17.006 11.9206 17.9396 12.8047C18.8732 13.6887 19.5799 14.7848 20 16L22.4 15.2C21.7045 13.0992 20.3631 11.2719 18.5672 9.97884C16.7714 8.68582 14.6129 7.99325 12.4 8H12.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_3000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/Undo.75f6b860d345438afe977ff99c0b50f2.svg";
export { ForwardRef as ReactComponent };